export default "__VITE_ASSET__BIyXDyAu__"